@if (loaderIcon | async) {
  <app-loader></app-loader>
}
<!-- Reservation follow up start -->

<!-- Collection Call follow up start -->
<div bsModal #collectionPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        @if (!EditFollowUpForm.get('checkboxCollectionCall').value &&
          (moduleType == 1 && FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental')) {
          <h5 class="modal-title">Rental Follow Up</h5>
        }
        @if (moduleType == 1 && FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation') {
          <h5 class="modal-title"
            >
          Reservation Follow Up</h5>
        }
        @if (moduleType == 1 && FollowUpData?.InquiryNumber && FollowUpData?.Type == 'Inquiry') {
          <h5 class="modal-title"
            >Inquiry
          Follow Up</h5>
        }
        @if (moduleType == 2) {
          <h5 class="modal-title">Add Follow-Up</h5>
        }
        @if (EditFollowUpForm.get('checkboxCollectionCall').value && (moduleType == 1 && FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental')) {
          <h5 class="modal-title"
            >
          Collection Call Follow Up</h5>
        }
        <button type="button" class="close pull-right" (click)="resetForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      @if (Follow_det) {
        <div class="modal-body followup_scroll">
          <div class="row mx-0 w-100 mb-2">
            <app-call-script [section]="section" style="width: 100%;"></app-call-script>
          </div>
          <div class="row">
            <div class="col-md-3 batch_revdet">
              <ul>
                <li>
                  <label>Tenant Name</label>
                  <p>{{FollowUpData?.TenantName}}</p>
                </li>
                <li>
                  <label>Phone</label>
                  <p> {{FollowUpData?.Phone | phone:1}}</p>
                </li>
                <li>
                  <label>E-Mail</label>
                  <p>{{FollowUpData?.Email}}</p>
                </li>
                @if (FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation') {
                  <li>
                    <label>Unit Type</label>
                    <p>{{FollowUpData?.UnitType}}</p>
                  </li>
                }
                @if (FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation') {
                  <li>
                    <label>Unit #</label>
                    <p>{{FollowUpData?.UnitNumber}}</p>
                  </li>
                }
              </ul>
            </div>
            @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
              <div class="col-md-3 batch_revdet"
                >
                <ul>
                  <li>
                    <label>Unit #</label>
                    <p>{{FollowUpData?.UnitNumber}}</p>
                  </li>
                  @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
                    <li>
                      <label>Unit Type</label>
                      <p>{{FollowUpData?.UnitType}}</p>
                    </li>
                  }
                  @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
                    <li>
                      <label>Lease #</label>
                      <p>{{FollowUpData?.LeaseNumber}}</p>
                    </li>
                  }
                  @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
                    <li>
                      <label>Billing Type</label>
                      <p>{{FollowUpData?.BillingType}}</p>
                    </li>
                  }
                  @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
                    <li>
                      <label>Billing Cycle</label>
                      <p>{{FollowUpData?.BillingCycle}}</p>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental') {
              <div class="col-md-3 batch_revdet"
                >
                <ul>
                  <li>
                    <label>Move-In Date</label>
                    <p>{{FollowUpData?.MoveInDate | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Longevity</label>
                    <p>{{FollowUpData?.Longevity}}</p>
                  </li>
                  <li>
                    <label>Status</label>
                    <p>{{FollowUpData?.Status}}</p>
                  </li>
                  <li>
                    <label>Paid Thru Date</label>
                    <p>{{FollowUpData?.PaidThruDate | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Sch.Move Out</label>
                    <p>{{FollowUpData?.ScheduledMOveOut | date: 'MM/dd/yyyy'}}</p>
                  </li>
                </ul>
              </div>
            }
            @if (FollowUpData?.InquiryNumber && FollowUpData?.Type == 'Inquiry') {
              <div class="col-md-4 batch_revdet"
                >
                <ul>
                  @if (FollowUpData?.InquiryNumber && FollowUpData?.Type == 'Inquiry' && FollowUpData?.InquiryNumber != 1) {
                    <li
                      >
                      <label>Inquiry #</label>
                      <p>{{FollowUpData?.InquiryNumber}}</p>
                    </li>
                  }
                  <li>
                    <label>Inquiry Date</label>
                    <p>{{FollowUpData?.InquiryDate | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Date Needed</label>
                    <p>{{FollowUpData?.DateNeeded | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Inquiry Source</label>
                    <p>{{FollowUpData?.InquirySource}}</p>
                  </li>
                  <li>
                    <label>Disposition</label>
                    <p>{{FollowUpData?.DispositionName}}</p>
                  </li>
                </ul>
              </div>
            }
            @if (FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation') {
              <div class="col-md-3 batch_revdet"
                >
                <ul>
                  @if (FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation' && FollowUpData?.ReservationNumber != 1) {
                    <li
                      >
                      <label>Reservation #</label>
                      <p>{{FollowUpData?.ReservationNumber}}</p>
                    </li>
                  }
                  <li>
                    <label>Reservation Date</label>
                    <p>{{FollowUpData?.ReservationDate | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Date Needed</label>
                    <p>{{FollowUpData?.DateNeeded | date: 'MM/dd/yyyy'}}</p>
                  </li>
                  <li>
                    <label>Reservation Source</label>
                    <p>{{FollowUpData?.InquirySource}}</p>
                  </li>
                  <li>
                    <label>Disposition</label>
                    <p>{{FollowUpData?.DispositionName}}</p>
                  </li>
                </ul>
              </div>
            }
            <div class="col-md-3 batch_revdet">
              <ul>
                @if ((FollowUpData?.ReservationNumber && FollowUpData?.Type == 'Reservation') ||
                  (FollowUpData?.InquiryNumber && FollowUpData?.Type == 'Inquiry')) {
                  <li>
                    <label>Deposit</label>
                    <p>{{FollowUpData?.Deposit | currency}}</p>
                  </li>
                }
                <li>
                  <label>Rent</label>
                  <p>{{FollowUpData?.Rent | currency}}</p>
                </li>
                <li>
                  <label>Discount</label>
                  <p>({{FollowUpData?.DiscountOffered | currency}})</p>
                </li>
                <li>
                  <label>Fees</label>
                  <p>{{FollowUpData?.Fees | currency}}</p>
                </li>
                @if (FollowUpData?.PropertyProtection > 0) {
                  <li>
                    <label>{{propertyProtectionLabel}}</label>
                    <p>{{FollowUpData?.PropertyProtection | currency}}</p>
                  </li>
                }
                <li>
                  <label>Tax</label>
                  <p>{{FollowUpData?.TotalTax | currency}}</p>
                </li>
                <li>
                  <label>Total Amount</label>
                  <strong>{{FollowUpData?.Total | currency}}</strong>
                </li>
                @if (FollowUpData?.Balance) {
                  <li>
                    <label>Balance</label>
                    <strong>{{FollowUpData?.Balance | customCurrency}}</strong>
                  </li>
                }
              </ul>
            </div>
          </div>
          @if ((moduleType == 1 && FollowUpData?.LeaseNumber && FollowUpData?.Type == 'Rental')) {
            <div class="d-flex gap-2 mt-2">
              <button class="btn btn-outline-primary" (click)="ShowalternateContact()">Alternate Contact</button>
              <button class="btn btn-outline-primary"
                (click)="openNotesModal()">
                Notes
              </button>
            </div>
          }
          <div class="row mx-0 bg_gray mt-3 pt-3">
            <div class="col-md-6 pe-5 m-padding-X15">
              <form [formGroup]="EditFollowUpForm">
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label class="pure-material-checkbox mb-0 me-3">
                      <input type="checkbox" class="custom-control-input"
                        formControlName="checkboxCollectionCall" appHighlightCallScriptFields
                        [fieldName]="'checkboxCollectionCall'"
                        [linkedFieldsList]="callScriptFields">
                        <span>Collection Call</span>
                      </label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Follow-Up Action@if (EditFollowUpForm.get('SelectedFollowUpAction').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <select (change)="showButton()" formControlName="SelectedFollowUpAction"
                          class="form-select" appHighlightCallScriptFields
                          [fieldName]="'SelectedFollowUpAction'"
                          [linkedFieldsList]="callScriptFields">
                          @for (act of FollowUpActionlist; track act) {
                            <option [value]="act.Id">{{act.Name}}
                            </option>
                          }
                        </select>
                        @if (EditFollowUpForm.get('SelectedFollowUpAction').errors !== null && (EditFollowUpForm.get('SelectedFollowUpAction').dirty || EditFollowUpForm.get('SelectedFollowUpAction').touched)) {
                          <div class="alert alert-danger"
                            >
                            @if (EditFollowUpForm.get('SelectedFollowUpAction').errors.required) {
                              <span
                                >Follow-Up
                              Action is required</span>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label>Status@if (EditFollowUpForm.get('SelectedStatus').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <select formControlName="SelectedStatus" class="form-select"
                          appHighlightCallScriptFields [fieldName]="'SelectedStatus'"
                          [linkedFieldsList]="callScriptFields">
                          @for (sta of StatusActionlist; track sta) {
                            <option [value]="sta.Id">{{sta.Name}}
                            </option>
                          }
                        </select>
                        @if (EditFollowUpForm.get('SelectedStatus').errors !== null && (EditFollowUpForm.get('SelectedStatus').dirty || EditFollowUpForm.get('SelectedStatus').touched)) {
                          <div class="alert alert-danger"
                            >
                            @if (EditFollowUpForm.get('SelectedStatus').errors.required) {
                              <span>Status
                              is required</span>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label>Reminder Date@if (EditFollowUpForm.get('Reminderdate').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <div>
                          <ejs-datepicker Class="form-control p-0 ejsgrid-height h-auto"
                            formControlName="Reminderdate" [min]="remainderMinDate"
                            floatLabelType='Always' format='MM/dd/yyyy'
                            [showTodayButton]='showTodayButtonReminderDate'
                            (renderDayCell)="onLoadEnabledDates($event)"
                            appHighlightCallScriptFields [fieldName]="'Reminderdate'"
                            [linkedFieldsList]="callScriptFields">
                          </ejs-datepicker>
                          @if (EditFollowUpForm.get('Reminderdate').errors !== null && (EditFollowUpForm.get('Reminderdate').dirty || EditFollowUpForm.get('Reminderdate').touched)) {
                            <div class="alert alert-danger"
                              >
                              @if (EditFollowUpForm.get('Reminderdate').errors.required) {
                                <span
                                  >Reminder
                                Date is required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Follow-Up Date@if (EditFollowUpForm.get('MentionedFollowUpdate').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <div>
                          <ejs-datepicker Class="form-control p-0 ejsgrid-height h-auto" [min]="minDate"
                            formControlName="MentionedFollowUpdate"
                            (change)="changeStartDate($event.value)" floatLabelType='Always'
                            format='MM/dd/yyyy' appHighlightCallScriptFields
                            [fieldName]="'MentionedFollowUpdate'"
                            [linkedFieldsList]="callScriptFields">
                          </ejs-datepicker>
                          @if (EditFollowUpForm.get('MentionedFollowUpdate').errors !== null && (EditFollowUpForm.get('MentionedFollowUpdate').dirty || EditFollowUpForm.get('MentionedFollowUpdate').touched)) {
                            <div class="alert alert-danger"
                              >
                              @if (EditFollowUpForm.get('MentionedFollowUpdate').errors.required) {
                                <span
                                  >Follow-Up
                                Date is required</span>
                              }
                            </div>
                          }
                        </div>
                      </div>
                      <div class="form-group">
                        <label>Priority@if (EditFollowUpForm.get('SelectedPriority').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <select class="form-select" formControlName="SelectedPriority"
                          appHighlightCallScriptFields [fieldName]="'SelectedPriority'"
                          [linkedFieldsList]="callScriptFields">
                          @for (prio of priorityActionlist; track prio) {
                            <option [value]="prio.Id">
                              {{prio.Name}}
                            </option>
                          }
                        </select>
                        @if (EditFollowUpForm.get('SelectedPriority').errors !== null && (EditFollowUpForm.get('SelectedPriority').dirty || EditFollowUpForm.get('SelectedPriority').touched)) {
                          <div class="alert alert-danger"
                            >
                            @if (EditFollowUpForm.get('SelectedPriority').errors.required) {
                              <span
                                >Follow-Up
                              Date is required</span>
                            }
                          </div>
                        }
                      </div>
                      <div class="form-group">
                        <label>Assigned To @if (EditFollowUpForm.get('SelectedAssignedTo').validator !== null) {
                          <span class="required"
                          >*</span>
                        }</label>
                        <ejs-dropdownlist #AssignedToDrop id='assignedTo' [dataSource]='assignedToList'
                          [placeholder]='groupWaterMark' [fields]='groupFields' [popupHeight]='height'
                          formControlName="SelectedAssignedTo" appHighlightCallScriptFields
                          [fieldName]="'SelectedAssignedTo'" [linkedFieldsList]="callScriptFields"
                          (change)="onChangeAssignedTo($event)">
                        </ejs-dropdownlist>
                        @if (EditFollowUpForm.get('SelectedAssignedTo').errors !== null && (EditFollowUpForm.get('SelectedAssignedTo').dirty || EditFollowUpForm.get('SelectedAssignedTo').touched)) {
                          <div class="alert alert-danger"
                            >
                            @if (EditFollowUpForm.get('SelectedAssignedTo').errors.required) {
                              <span
                                >Assigned
                              To is required</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Notes@if (EditFollowUpForm.get('EditableNotes').validator !== null) {
                      <span class="required"
                      >*</span>
                    }</label>
                    <textarea rows="3" class="form-control" formControlName="EditableNotes"
                      appHighlightCallScriptFields [fieldName]="'EditableNotes'"
                    [linkedFieldsList]="callScriptFields" appRestrictHtmltagchars></textarea>
                    @if (EditFollowUpForm.get('EditableNotes').errors !== null && (EditFollowUpForm.get('EditableNotes').dirty || EditFollowUpForm.get('EditableNotes').touched)) {
                      <div class="alert alert-danger"
                        >
                        @if (EditFollowUpForm.get('EditableNotes').errors.required || EditFollowUpForm.get('EditableNotes').errors.pattern) {
                          <span>Notes is
                          required</span>
                        }
                      </div>
                    }
                  </div>
                </form>
              </div>
              <div class="col-md-6">
                @if (showdripdetails) {
                  <div>
                    <p><strong>DripCampaign Action :</strong> {{ DripcampaignName}} - {{ DripcampaignActionName }}</p>
                  </div>
                }
                <div class="form-group mb-0 batch_rev_follow_notes">
                  <label>Follow-Up Notes</label>
                  <div class="scroll_outer">
                    <div class="scroll_inner_small">
                      <div class="bordered_table">
                        <table
                          class="table table-striped bg-white table-hover note-table mb-0 table-norm-ipad">
                          <thead>
                            <tr>
                              <th width="25%">Created By</th>
                              <th class="text-center" width="25%">Created Date</th>
                              <th width="50%">Notes</th>
                            </tr>
                          </thead>
                        </table>
                        <div class="follow_Table_scroll" style="overflow-y: auto;" infinite-scroll>
                          <table
                            class="table table-striped table-responsive bg-white table-hover note-table mb-0">
                            <tbody>
                              @for (notedata of notesGridData; track notedata) {
                                <tr
                                  (click)="ShowDetNote(notedata.NotesId,1)">
                                  <td>{{notedata.Creator}}</td>
                                  <td class="text-center">{{notedata.NotesDate | date: 'MM/dd/yyyy
                                  h:mm:ss'}}</td>
                                  <td [title]="notedata.Text"><a tabindex="-1"
                                  class="customer--address">{{notedata.Text}}</a>
                                  <div class="detail_note_followup"
                                    [style.visibility]="NoteDetail && notedata.NotesId == currentNotesId? 'visible' : 'hidden'"
                                    (click)="HideNotePopUp(notedata.NotesId)">
                                    <b>Note</b>
                                    <p>{{notedata.Text}}</p>
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (Caller_det) {
        <div class="modal-body followup_scroll">
          <div class="row text-center">
            <div class="col-md-4 m-auto">
              <div class="caller_det">
                <img width="45" height="45" src="../../../../assets/images/phone_ring.svg" />
                <p>Calling....</p>
                <strong>{{FollowUpData?.TenantName}}</strong>
                <b>{{FollowUpData?.Phone | phone:1}}</b>
                <button type="button" (click)="EndCall()" class="btn btn-danger w-35">End Call</button>
              </div>
            </div>
            <div class="col-md-11 mx-auto my-3">
              <label for="" class="d-block text-start">Call Script </label>
              <textarea class="form-control" rows="5" [(ngModel)]="callscrpt" disabled></textarea>
            </div>
          </div>
        </div>
      }
      <div class="modal-footer ">
        @if (moduleType == 1 && Follow_det && SelectedFollowUpData) {
          <div class="me-auto">
            @if (SelectedFollowUpData?.FollowUpActionId == 232 && viewRightAdHocSMS) {
              <div class="phone_caller"
                >
                @if (BeforeSMS) {
                  <button type="button" class="btn btn-primary showButton button_tooltip"
                    (click)="openSmsModal()">
                    <i class="fa fa-comment-o"></i>
                    @if ((!createRightAdHocSMS && viewRightAdHocSMS)) {
                      <div class="button_tooltip_modal" style="left:63px;text-transform: none;"
                        >
                        @if ((!createRightAdHocSMS && viewRightAdHocSMS)) {
                          <p class="mb-0">
                          {{createRightFalseMessage}}</p>
                        }
                        <i class="fa fa-caret-down .text-dark h2 butt_downIcon" style="left:26px"
                        aria-hidden="true"></i>
                      </div>
                    }
                  </button>
                }
                @if (AfterSMS) {
                  <button type="button" class="btn btn-success showButton">
                    <i class="fa fa-comment-o"></i>
                  </button>
                }
              </div>
            }
            @if (SelectedFollowUpData?.FollowUpActionId == 230) {
              <div class="phone_caller">
                <button (click)="openCallSystem()" type="button" class="btn btn-primary showButton">
                  <i class="fa fa-phone"></i>
                </button>
              </div>
            }
            @if (SelectedFollowUpData?.FollowUpActionId == 231 && viewRightAdHocEmail) {
              <div class="phone_caller"
                >
                @if (BeforeEmail) {
                  <button type="button" class="btn btn-primary showButton button_tooltip"
                    (click)="openemailModal()">
                    <i class="fa fa-envelope-o"></i>
                    @if ((!createRightAdHocEmail && viewRightAdHocEmail)) {
                      <div class="button_tooltip_modal" style="left:63px;text-transform: none;"
                        >
                        @if ((!createRightAdHocEmail && viewRightAdHocEmail)) {
                          <p class="mb-0">
                          {{createRightFalseMessage}}</p>
                        }
                        <i class="fa fa-caret-down .text-dark h2 butt_downIcon" style="left: 26px"
                        aria-hidden="true"></i>
                      </div>
                    }
                  </button>
                }
                @if (AfterEmail) {
                  <button type="button" class="btn btn-success showButton">
                    <i class="fa fa-envelope-o"></i>
                  </button>
                }
              </div>
            }
          </div>
        }

        <div>
          <button type="button" class="btn btn-outline-primary me-3" (click)="resetForm()">Cancel</button>
          <button type="button" class="btn btn-primary button_tooltip"
            [disabled]="!EditFollowUpForm.valid || (!editRight && (moduleType == 1)) || !EditFollowUpForm.dirty"
            (click)="makeFollowupModel()">Save
            @if ((!editRight && (moduleType == 1))) {
              <div class="button_tooltip_modal">
                @if ((!editRight && (moduleType == 1))) {
                  <p class="mb-0">{{editRightFalseMessage}}</p>
                }
                <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
              </div>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Email modal -->
<div class="modal fade" bsModal #EmailModal="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal_650 modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Send Email</h5>
        <button type="button" class="close pull-right" (click)="closeemailModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body followup_scroll">
        <div class="row mx-0">
          <div class="align-items-center d-flex w-100">
            <label>Template :</label>
            <select class="form-select w-50 ms-2" [(ngModel)]="templateTTTypeID"
              (ngModelChange)="onTemplateChange($event)">
              <option selected value="0" disabled>-Select-</option>
              @for (baseTemplate of templateList; track baseTemplate) {
                <option [value]="baseTemplate.Id">
                  {{baseTemplate.Name}}
                </option>
              }
            </select>
          </div>
        </div>
        <div class="row mt-3 mx-0 sendemail_textarea">
          <ejs-richtexteditor class="height400 mt-3" #defaultRTE [(value)]="rteValue"
            [toolbarSettings]='toolbarConfig'>
          </ejs-richtexteditor>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" (click)="closeemailModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="sendEmail()"
        [disabled]="disableEmailSend">Send</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #SMSModal="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          Send Message <br>
          <span>{{FollowUpData?.Phone | phone:1}}</span>
        </h5>
        <button type="button" class="close" (click)="closeSmsModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="chat_box message_detail_out">
          <div class="scroll_sec" #scrollMe [scrollTop]="scrollMe.scrollHeight">
            @for (msg of filteredLogs; track msg) {
              <div>
                <label [ngClass]="{'reply_msg': msg.Type==368}">{{msg.Message}}</label>
              </div>
            }
            <span class="no-sms">{{noMessages}}</span>
          </div>
          <div class="detail_bot_sec">
            <span class="letter-count">{{smstext.length}}/160</span>
            <textarea rows="5" class="form-control mb-3" [(ngModel)]="smstext" maxlength="160"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="closeSmsModal()">Close</button>
        <div class="form-group button_tooltip mb-0">
          <button type="button" class="btn btn-primary" [disabled]="!FollowUpData?.SendSMSAlerts || !isCellPhoneAvailable" (click)="sendTheSms()">Send</button>
          @if (!FollowUpData?.SendSMSAlerts || !isCellPhoneAvailable) {
            <div class="button_tooltip_modal">
              <p class="mb-0">{{ !isCellPhoneAvailable ? 'No Cell Phone number is available to send SMS.' : !FollowUpData?.SendSMSAlerts ? 'Please select the SMS checkbox!' : '' }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" bsModal #NotesPopup="bs-modal"
  tabindex="-1" role="dialog" aria-hidden="true">

  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <div class="modal-header d-flex justify-content-between align-items-center">
        <h5 class="modal-title mb-0">Notes</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeNotesPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <div class="table-responsive" style="overflow-x: hidden;">
          <table class="table table-striped table-hover mb-0 bg-white">
            <colgroup>
            <col style="width: 23%">
            <col style="width: 18%">
            <col style="width: 16%">
            <col style="width: 43%">
          </colgroup>

          <thead class="table-primary">
            <tr>
              <th>Created Date</th>
              <th>Created By</th>
              <th>Notes Type</th>
              <th>Notes</th>
            </tr>
          </thead>
        </table>

        <div infinite-scroll style="overflow-y: auto; overflow-x: hidden; max-height: 250px;" [scrollWindow]="false">
          <table class="table table-striped table-hover mb-0 bg-white" id='scrollMe'>
            <colgroup>
            <col style="width: 23%">
            <col style="width: 18%">
            <col style="width: 16%">
            <col style="width: 43%">
          </colgroup>

          <tbody>
            @for (note of customerNotesList; track note) {
              <tr>
                <td>
                  {{ note.NotesDate | date:'MM/dd/yyyy hh:mm:ss a' }}
                </td>
                <td>{{ note.AddedBy }}</td>
                <td>{{ note.Type }}</td>
                <td [title]="note.Notes">
                  {{ note.Notes }}
                </td>
              </tr>
            }

            <!-- No Data -->
            @if (!customerNotesList?.length) {
              <tr>
                <td colspan="4" class="text-center text-muted">
                  No notes found
                </td>
              </tr>
            }

          </tbody>

        </table>
      </div>
    </div>

  </div>

</div>
</div>
</div>

<div bsModal #AlternateContactPopUp="bs-modal" [config]="alternateModalConfig" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Alternate Contact</h5>
        <button type="button" class="close" aria-label="Close"
          (click)="CancelAlternantePopUp()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="height: 250px;">
        @if (gotoalternateContact) {
          <app-alternate-contact [ContactList]="alternateContactInfoList"
            [noOfContacts]="alternateContactInfoList.length" [FacilityId]="FollowUpData.FacilityId"
            [readonlyMode]="true" [FacilitygateSystemResponse]="gateSystemResponse" [tenantCountryId]="1">
          </app-alternate-contact>
        }
      </div>
    </div>
  </div>
</div>
